import { Select } from "antd";
import { useEffect } from "react";
import { SizeType } from "antd/es/config-provider/SizeContext";
import { useSelector } from "react-redux";
import { getMyDependencies } from "../../../../controllers/store/actions/entities/get-dependencies-action";
import store from "../../../../controllers/store";

interface Props {
  onChange: (value: any) => void;
  onClear?: () => void;
  size?: SizeType;
  filterActor?: string;
  mode?: any;
  defaultValue?: string;
  style?: any;
}
const dispatch = store.dispatch;
const SelectEntityDependency = (props: Props) => {
  const userState = useSelector((state: any) => state.user.user);
  const dependenciesState = useSelector((state: any) => state.dependencies);

  useEffect(() => {
    if (userState?.user?.me?.role?.name === "admin") {
      dispatch(getMyDependencies(""));
    } else {
      dispatch(getMyDependencies(userState.me.id));
    }
  }, [userState.me.id]);

  const filterOption = (
    input: string,
    option?: { label: string; value: string }
  ) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  return (
    <div style={{ width: "100%" }}>
      <Select
        {...props}
        labelInValue
        showSearch
        optionFilterProp="children"
        filterOption={filterOption}
        allowClear
        mode={props?.mode}
        onClear={() => {
          if (props.onClear) {
            props?.onClear();
          }
        }}
        size={props.size}
        defaultValue={props?.defaultValue || []}
        style={props.style}
        onChange={(selected: any) => {
          if (Array.isArray(selected)) {
            return props.onChange(selected);
          }

          if (selected) {
            props.onChange({
              ...selected,
              selectedActor: dependenciesState?.dependencies.find(
                (dependency: any) => dependency.id === selected.value
              ),
            });
          }
        }}
        options={dependenciesState?.dependencies
          ?.filter((a: any) => {
            if (!props.filterActor) {
              return true;
            } else {
              return props.filterActor === a.type.collection_name;
            }
          })
          .map((dependency: any) => ({
            label: dependency.name,
            value: dependency.id,
          }))}
      />
    </div>
  );
};

export default SelectEntityDependency;
